<template>
  <div id="filters_col">
    <a
      data-toggle="collapse"
      href="#collapseFilters"
      aria-expanded="false"
      aria-controls="collapseFilters"
      id="filters_col_bt"
      >Filters
    </a>
    <div class="collapse show" id="collapseFilters">
      <div class="filter_type">
        <h6>Pincode</h6>

        <input
          type="text"
          id="pincode"
          name="pincode"
          v-model="search.pincode"
          @keyup="() => loadNearbyOffers(search)"
          class="form-control"
        />
      </div>
       <div class="filter_type">
         <h6>Location</h6>
             <div class="form-group text-black">
              <vue-simple-suggest   
                v-model="search.location"
                display-attribute="name"
                value-attribute="url"
                :list="getSuggestionList"
                @select="getvalue($event)"
              ></vue-simple-suggest>

              <br />
            
             <a href="javascript:void(0);" @click="currentLoc()"> <i class="icon_pin_alt" > </i> Use Current Location</a> 
            </div>
             {{search.range+ "Km"}}

         <input type="range" class="form-range " list="tickmarks" min="0" max="20" v-model="search.range" />
        </div>    
          
      <div class="filter_type">
        <h6>Discount</h6>
        <div class="row">
          <div class="col-md-12">
            <center>
              <input
                type="radio"
                v-model="search.discount_type"
                value=""
                @change="() => loadNearbyOffers(search)"
                selected
              />
              ALL
              <input
                type="radio"
                v-model="search.discount_type"
                value="percent"
                @change="() => loadNearbyOffers(search)"
                selected
              />
              %
              <input
                type="radio"
                v-model="search.discount_type"
                value="value"
                @change="() => loadNearbyOffers(search)"
              />
              <i class="fa fa-inr"></i>
            </center>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            Min:
            <input
              type="number"
              id="min-discount"
              name="min-discount"
              class="form-control"
              v-model="search.mindiscount"
              min="0"
              max="100"
              @change="() => loadNearbyOffers(search)"
              @blur="() => loadNearbyOffers(search)"
            />
          </div>
          <div class="col-md-6">
            Max:
            <input
              type="number"
              id="max-discount"
              name="max-discount"
              class="form-control"
              v-model="search.maxdiscount"
              min="0"
              max="100"
              @change="() => loadNearbyOffers(search)"
              @blur="() => loadNearbyOffers(search)"
            />
          </div>
        </div>
      </div>
      <div class="filter_type" v-show="subCatList.length > 0">
        <h6>Sub Categories</h6>
        <ul>
          <li v-for="cat in subCatList" :key="cat.id">
            <label class="container_check" v-if="cat.category != ''"
              >{{ cat.category }}
              <input
                type="checkbox"
                :value="cat.id"
                v-model="search.subcategories"
                @click="() => loadNearbyOffers(search)"
              />{{ cat.text }}
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div>

      <div class="filter_type">
        <h6>Rating</h6>
        <ul>
          <li>
            <label class="container_check"
              >Superb 9+ <small>(25)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Very Good 8+ <small>(26)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Good 7+ <small>(25)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Pleasant 6+ <small>(12)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <!--/filters col-->
  </div>
</template>

        <script>
import API from "../services/index";
//import { EventBus } from "@/EventBus.js";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  props: ["search", "loadNearbyOffers", "catList", "subCatList"],
  components:{VueSimpleSuggest},
  methods: {
      getSuggestionList () {
      var i =[]
      var config = {
    headers: {
    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
      if (this.search.location.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.location}`,config)
          .then(function (response) {
        response.data.features.forEach(function (feature) {
            i.push(`${feature.properties.name} ${feature.properties.state} ${feature.properties.country} ${feature.properties.postcode?feature.properties.postcode:feature.properties.countrycode}`) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
     currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.error = 'Geolocation is not supported.'
      }
    },
   showPosition(position){
  position.coords.latitude
  position.coords.longitude
  var location = [position.coords.latitude,position.coords.longitude]
  this.SuggestionList(location)
      
   }, 
   SuggestionList(location){
      var i = [];
      // if (this.search.location.length >= 2) {
         API.get(`https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county?feature.properties.county:"" +
                  " " +
                  " " +
                  feature.properties.state?feature.properties.state:"" +
                  " " +
                  feature.properties.postcode?feature.properties.postcode:""
              );
            });
            var uniq = [...new Set(i)];
            this.search.location = uniq[1]        
          })

          .catch(function (error) {
            console.log(error);
          });
 },
  getvalue(value){
      // var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then( (response)=> {
         var j =0 ;
          response.data.features.forEach( (feature)=> {
            if(j === 0){
               this.search.geocodes = feature.geometry.coordinates
            // i= feature.geometry.coordinates;
            }
           j++;
          });
          this.loadNearbyOffers(this.search)
        })
        .catch(function (error) {
          console.log(error);
        });  
        
    }
  }
};
</script>